import {SearchOutlined} from '@ant-design/icons'
import SearchPane from './SearchPane.jsx'

export default () => {
    return {
        icon: <SearchOutlined />,
        key: 'search',
        name: '搜索',
        pane: <SearchPane />,
    }
}
